import { RequestStatus } from '@/helpers/entities/enums/v2/RequestStatus';
export class RequestModel {
    constructor(request) {
        const { uuid, details, status } = request;
        this.uuid = uuid;
        this.details = details;
        this.status = status;
    }
    get approved() {
        return this.status === RequestStatus.approved;
    }
    get pending() {
        return this.status === RequestStatus.pending;
    }
    get declined() {
        return this.status === RequestStatus.declined;
    }
}
